import { useMemo } from "react";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { NavAside } from "./components/NavAside";
import { Toasts } from "./components/Toasts";
import { Facet } from "./filter/Facet";
import { Filter } from "./filter/Filter";
import { MapViewControls } from "./map/controls/MapViewControls";
import { menuInfo } from "./menu";
import { DemoProjects } from "./projects/DemoProjects";
import { ProjectBar } from "./projects/ProjectBar";
import { ProjectDetailView } from "./projects/ProjectDetailView";
import { Projects } from "./projects/Projects";
import { SharedProjectView } from "./projects/SharedProjectView";
import { Report } from "./report/Report";
import { sectionInfo } from "./report/sections";
import { onClickScrollToSection } from "./report/sections/Section";
import { Search } from "./search/Search";
import { useAccount } from "./state";
import { UserPage } from "./user/UserPage";

const Location = (
  <>
    <MapViewControls />
    <Report />
  </>
);

const Aside = () => {
  const [p0, _p1, p2] = useParams()["*"].split("/");
  const navigate = useNavigate();
  const loggedIn = useAccount((s) => Boolean(s.user));
  const onClick = useMemo(
    () => (e) => {
      const name = e.currentTarget?.dataset?.name;
      if (name !== undefined) navigate(`/${name}`);
    },
    [navigate]
  );

  if (p0 === "location")
    return (
      <NavAside sectionInfo={sectionInfo} onClick={onClickScrollToSection} active={p2 || "base"} />
    );
  const menu = loggedIn ? menuInfo : menuInfo.filter((e) => e[0] !== "projects");
  return <NavAside sectionInfo={menu} onClick={onClick} active={p0} />;
};

const Main = () => {
  const user = useAccount((s) => s.user);
  const PR = user?.username === "wout@vanrielgrondbegrip.nl" ? DemoProjects : Projects;
  return (
    <main>
      <Aside />
      {user && <ProjectBar />}
      <Routes>
        <Route
          path="/"
          element={
            <Search className="fixed z-10 flex flex-col top-16 left-13 sm:left-22 w-3/4 sm:w-[29rem]" />
          }
        />
        <Route path="/filter" element={<Filter />} />
        <Route path="/search" element={<Facet />} />
        <Route path="/projects" element={<PR />} />
        <Route path="/projects/:id" element={<ProjectDetailView />} />
        <Route path="/shared/:token" element={<SharedProjectView />} />
        <Route path="/user" element={<UserPage />} />
        <Route path="/location/*" element={Location} />
      </Routes>
      <Toasts />
    </main>
  );
};

export { Main };
